import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type ConfirmUserCall = (
  userID: number,
  token: string,
) => Promise<{ data: null }>;

export default (makeCall: MakeCall) => (userID: number, token: string) =>
  makeCall<undefined>('PUT', `/api/v2/user/${userID}/confirm`, {
    data: { token },
  });
